import React from "react";
import { useMediaQuery } from "react-responsive";
import { translate } from "react-i18next";
import groupImg from "../../assets/media/revised/group-3@2x.jpg";
import guard from "../../assets/media/revised/security_guard.png";
import housewife from "../../assets/media/revised/housewife.jpg";

// import customer1 from "../../assets/media/revised/customer/cus1.png";
// import customer2 from "../../assets/media/revised/customer/cus2.png";
// import customer3 from "../../assets/media/revised/customer/cus3.png";
// import customer4 from "../../assets/media/revised/customer/cus4.png";
// import customer5 from "../../assets/media/revised/customer/cus5.png";
// import customer6 from "../../assets/media/revised/customer/cus6.png";
// import customer7 from "../../assets/media/revised/customer/cus7.png";
// import customer8 from "../../assets/media/revised/customer/cus8.png";
// import customer9 from "../../assets/media/revised/customer/cus9.png";
// import customer10 from "../../assets/media/revised/customer/cus10.png";
import alllogo from "../../assets/media/revised/customer/alllogo.png";
import alllogomobile from "../../assets/media/revised/customer/alllogomobile.png";

function Partner({ t, i18n }) {
	const url_lang = i18n.language === "en" ? "/en" : "";
	const isMobile = useMediaQuery({ maxWidth: 600 });

	return (
		<div>
			<figure>
				<div className="container">
					<img className="center-img" src={groupImg} alt="" />
					<div className="partner-hero">
						<h1>{t("partner_hero1")}</h1>
						<h1>{t("partner_hero2")}</h1>
						<h1>{t("partner_hero3")}</h1>
						<p>{t("partner_hero4")}</p>
					</div>
				</div>
			</figure>
			<section>
				<div className="container-center" style={{ margin: "2rem 0" }}>
					<h2 className="main-title partner">{t("partner_title1")}</h2>
					<h2 className="main-title partner">{t("partner_title2")}</h2>
				</div>
				<div className="container">
					{isMobile ? (
						<img
							style={{ paddingBottom: "4rem" }}
							className="center-img"
							src={alllogomobile}
							alt=""
						/>
					) : (
						<img
							style={{ paddingBottom: "4rem" }}
							className="center-img"
							src={alllogo}
							alt=""
						/>
					)}

					{/* <div className="partner-group">
						<img className="partner-logo" src={customer1} alt="" />
						<img className="partner-logo" src={customer2} alt="" />
						<img className="partner-logo" src={customer3} alt="" />
						<img className="partner-logo" src={customer4} alt="" />
						<img className="partner-logo" src={customer5} alt="" />
						<img className="partner-logo" src={customer6} alt="" />
						<img className="partner-logo" src={customer7} alt="" />
						<img className="partner-logo" src={customer8} alt="" />
						<img className="partner-logo" src={customer9} alt="" />
						<img className="partner-logo" src={customer10} alt="" />
					</div> */}
					<div className="go-daycash-btn demo">
						<a
							className="go-daycash-btn--link demo"
							href={`${url_lang}/contact`}
						>
							{t("req_demo")}
							<span className="glyphicon glyphicon-arrow-right"></span>
						</a>
					</div>
				</div>
			</section>
			<figure style={{ marginTop: "5rem" }}>
				<div className="container">
					<div className="row">
						<div className="col-md-6 col-xs-12 p-0">
							<img className="center-img" src={guard} alt="" />
						</div>
						<div className="col-md-6 col-xs-12">
							<img className="center-img" src={housewife} alt="" />
						</div>
					</div>
				</div>
			</figure>
		</div>
	);
}

export default translate("translations")(Partner);



// WEBPACK FOOTER //
// ./src/components/home/Partner.jsx